import WordCount from './word-count.vue';
export default WordCount;


// WEBPACK FOOTER //
// ./src/components/word-count/index.js